(function(angular){
	'use strict';

	angular
		.module('ipoModule')
		.factory('ipoFactory', [
			'$http',
			'STATIC_BASE_PATH',
			IpoFactoryFunction
		]);

	function IpoFactoryFunction(
		$http,
		STATIC_BASE_PATH
	) {
		var factory = {
			'getKeyPerformanceIndicators': getKeyPerformanceIndicators
		};

		return factory;

		function getKeyPerformanceIndicators() {
			var chartUrl = STATIC_BASE_PATH + '/' + resolveStaticResource('static/json/ipo/key-performance-indicators.json');

			return $http.get(chartUrl).then(function(response){
				return response.data.keyPerformanceIndicatorsTable;
			});
		}
	}
})(window.angular);